<template>
  <div>
    <!-- <web-clients-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      :item.sync="itemEditable"
      @refetchData="refetchData"
    /> -->

    <b-card
      no-body
    >
      <div class="card-header">
        <b-card-title>Clientes del sitio</b-card-title>
      </div>

      <div class="mx-2 mb-2 mt-0">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="8"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label> -->
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="4"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />
              <!-- <b-button
                variant="primary"
                @click="isAddNewUserSidebarActive = true"
              >
                <span class="text-nowrap">Nuevo país</span>
              </b-button> -->
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refCountryListTable"
        :items="fetchCountries"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDirDesc"
        class="position-relative"
        responsive="sm"
        primary-key="id"
        empty-text="No se encontrado paises"
        show-empty
        striped
      >
        <!-- Column: country -->
        <template #cell(country)="data">
          {{ getCountry(data.item.country) }}
        </template>

        <!-- Column: alerts -->
        <template #cell(alerts)="data">
          <div class="d-flex flex-column align-items-start">
            <div
              v-for="alert in data.item.settings.alerts"
              :key="alert.type"
              style="margin-bottom: 4px"
            >
              <b-form-checkbox
                :id="alert.type"
                v-model="alert.checked"
                :name="alert.type"
                disabled
              >
                {{ dicAlerts[alert.type] }}
              </b-form-checkbox>
            </div>
          </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <!-- <feather-icon
              :id="`user-row-${data.item.id}-edit-icon`"
              icon="EditIcon"
              size="16"
              class="mx-1 cursor-pointer"
              @click="onEdit(data.item)"
            />
            <b-tooltip
              title="Editar usuario"
              :target="`user-row-${data.item.id}-edit-icon`"
            /> -->

            <div class="d-inline">
              <feather-icon
                v-if="!data.item.loading"
                :id="`user-row-${data.item.id}-delete-icon`"
                icon="TrashIcon"
                size="16"
                class="cursor-pointer"
                @click="onDelete(data.item)"
              />
              <b-spinner
                v-if="data.item.loading"
                :id="`user-row-${data.item.id}-delete-icon`"
                small
              />
              <b-tooltip
                :title="data.item.loading ? 'Eliminando...' : 'Eliminar usuario'"
                :target="`user-row-${data.item.id}-delete-icon`"
              />
            </div>
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} a {{ dataMeta.to }} de {{ dataMeta.of }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalCountries"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BCard,
  BCardTitle,
  BRow,
  BCol,
  BFormInput,
  BFormCheckbox,
  // BButton,
  // BDropdown,
  // BDropdownItem,
  BPagination,
  BTooltip,
  BSpinner,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import useCountries from '@/views/countries/useCountries'
// import WebClientsAddNew from './WebClientsAddNew.vue'
import useWebClients from './useWebClients'

export default {
  components: {
    // WebClientsAddNew,

    BCard,
    BTable,
    BCardTitle,
    BRow,
    BCol,
    BFormInput,
    BFormCheckbox,
    // BButton,
    // BDropdown,
    // BDropdownItem,
    BPagination,
    BTooltip,
    BSpinner,
  },
  setup() {
    const dicAlerts = {
      ALERT_EC_PERCENTAGE: '15% de retención. Decreto N. 313 en Ecuador',
    }
    const {
      fetchCountries,
      countryDelete,
      tableColumns,
      perPage,
      currentPage,
      totalCountries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refCountryListTable,
      refetchData,

      // UI
      // resolveUserRoleVariant,
      // resolveUserRoleIcon,
      // resolveUserStatusVariant,

      // Extra Filters
      // roleFilter,
      // planFilter,
      // statusFilter,
    } = useWebClients()

    const { countries } = useCountries()

    const isAddNewUserSidebarActive = ref(false)
    const itemEditable = ref(null)

    function getCountry(iso) {
      return countries.value.find(c => c.value === iso)?.label ?? ''
    }

    function onEdit(client) {
      itemEditable.value = { ...client }

      isAddNewUserSidebarActive.value = true
    }

    async function onDelete(client) {
      try {
        const result = await this.$swal({
          title: '¿Estas seguro?',
          text: '¡No podrás revertir esta acción!',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '¡Sí, bórralo!',
          cancelButtonText: 'Cancelar',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })

        if (result.value) {
          client.loading = true
          await countryDelete(client.id)
          client.loading = false
          refetchData()

          this.$swal({
            icon: 'success',
            title: '¡Borrado!',
            text: 'El cliente ha sido borrado',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      } catch (error) {
        console.log(error)
      }
    }

    return {
      isAddNewUserSidebarActive,
      itemEditable,
      refCountryListTable,

      dicAlerts,
      tableColumns,
      perPage,
      currentPage,
      totalCountries,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      searchQuery,
      fetchCountries,
      refetchData,
      onEdit,
      onDelete,
      getCountry,
    }
  },
}
</script>
